import { Redirect } from 'react-router'

import { RouteName } from './RouteName'

/**
 * 구 경로(북마크·딥링크) 하위호환 전용 리다이렉트 모음.
 *
 * 페이지를 옮길 때 RouteName 에 `legacy*` 상수로 구 경로를 남기고 여기에 추가
 * 3개월은 필수로 진행
 * 1달 정도 단위로 구 경로 인입량 보고 아카이브로 정리
 * https://freewheelin-workspace.slack.com/archives/C0B4TRY5X8B/p1781596077929839?thread_ts=1781590758.963989&cid=C0B4TRY5X8B
 */
const LEGACY_REDIRECTS: { from: string; to: string }[] = [
  // LNB 리뉴얼: theme-worksheet → exam / by-category 재편 (kmmExamWorksheet 는 잔류라 제외)
  { from: RouteName.legacyTextbookWorksheet, to: RouteName.textbookWorksheet },
  { from: RouteName.legacyRecommend, to: RouteName.recommend },
  { from: RouteName.legacyEssayWorksheet, to: RouteName.essayWorksheet },
  { from: RouteName.legacyPracticeTest, to: RouteName.practiceTest },
  { from: RouteName.legacyPracticeTestPair, to: RouteName.practiceTestPair },
  { from: RouteName.legacyThemeEntranceTest, to: RouteName.themeEntranceTest },
  { from: RouteName.legacyWeeklyTest, to: RouteName.weeklyTest },
  { from: RouteName.legacyChapterTest, to: RouteName.chapterTest },
  { from: RouteName.legacyGeneralTest, to: RouteName.generalTest },
  { from: RouteName.legacySatWorksheet, to: RouteName.satWorksheet },
  { from: RouteName.legacyPoliceMilitaryPracticeTest, to: RouteName.policeMilitaryPracticeTest },
  {
    from: RouteName.legacyPoliceMilitaryPracticeTestPair,
    to: RouteName.policeMilitaryPracticeTestPair,
  },
  { from: RouteName.legacyArithmetic, to: RouteName.arithmetic },
  { from: RouteName.legacySchoolExamZone, to: RouteName.schoolExamZone },
  { from: RouteName.legacyKmmExamWorksheet, to: RouteName.kmmExamWorksheet },
  // theme-worksheet 베이스(구 '테마별 추천학습지') 진입은 내신 대비 기본 탭으로
  { from: RouteName.legacyTheme, to: RouteName.textbookWorksheet },
]

export const legacyRouteRedirects = LEGACY_REDIRECTS.map(({ from, to }) => (
  <Redirect key={from} exact from={from} to={to} />
))
